/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, InjectReactive, Vue } from 'vue-property-decorator';
import { Empty } from '@hb/coffee';
import HomeBottomBar from '@/components/home-bottom-bar';
import type { Home } from '../../types';
import RiskStatement from '../../components/risk-statement';

const style: Dictionary = require('./index.module.scss');

@Component
export default class AliApplyFaildHome extends Vue {
  @InjectReactive() homePage!: Home;

  private mounted() {
    if (this.homePage) {
      this.homePage.hideLoading();
    }
  }

  private render() {
    return (
      <div class={style.aliApplyFaildHome}>
        <Empty
          class={style.empty}
          title="您的审批未通过"
          desc="抱歉，您暂无额度可用"
  />

        <HomeBottomBar />
      </div>
    );
  }
}
